import { render } from "./UangTipsEdit.vue?vue&type=template&id=f0110d2e&ts=true"
import script from "./UangTipsEdit.vue?vue&type=script&lang=ts"
export * from "./UangTipsEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/adminhost/web/cr55perjuangan.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__